import getMatrixType from "@secureo/common/utils/getMatrixType"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"

export const toggleLockingComponentSelections = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuid: string,
) => {
	const { lockingComponentsUuids, matrix } = reducerState

	const targetRowIndex = lockingComponentsUuids.findIndex(
		(componentUuid) => componentUuid === uuid,
	)
	const targetRow = matrix[targetRowIndex]

	const targetRowHasSelectedAllComponents = targetRow.every((isSelected) => isSelected)

	const updatedRow = targetRow.map(() => !targetRowHasSelectedAllComponents)

	matrix[targetRowIndex] = updatedRow

	const matrixType = getMatrixType(matrix)

	dispatch({
		type: "TOGGLE_ROW_SELECTIONS",
		payload: {
			matrix,
			matrixType,
		},
	})
}
